import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  selectCacheSessionId,
  selectCurrentReportId,
  selectSessionId,
} from "../../../../store/selectors/currentReportSelectors";
import { selectLogQueries } from "../../../../store/selectors/devToolsSelectors";
import {
  selectConditions,
  selectTileFields,
  selectTileSettingsState,
} from "../../../../store/selectors/fieldsStateSelectors";
import { createTileDataRequest } from "../utils/createTileDataRequest";
import type { BuildTileReportRequest } from "../../../../../../../../api/types/svTypes.ts";

const MaximumExportRecordsCount = 10000;

const useRequestConfigBuilder = () => {
  const fieldsAreaValues = useSelector(selectTileFields);
  const conditionsAreaValues = useSelector(selectConditions);
  const settingsAreaValues = useSelector(selectTileSettingsState);

  const reportId = useSelector(selectCurrentReportId);
  const sessionId = useSelector(selectSessionId);
  const cacheSessionId = useSelector(selectCacheSessionId);
  const isQueryLoggingActive = useSelector(selectLogQueries);

  const requestConfig = useMemo(() => {
    const request: BuildTileReportRequest = {
      ...createTileDataRequest(conditionsAreaValues, fieldsAreaValues, settingsAreaValues),
      sessionId,
      cacheSessionId,
      reportId: reportId ?? "",
      take: MaximumExportRecordsCount,
      skip: 0,
      useQueryLogging: isQueryLoggingActive === true,
    };
    return request;
  }, [
    conditionsAreaValues,
    fieldsAreaValues,
    settingsAreaValues,
    sessionId,
    cacheSessionId,
    reportId,
    isQueryLoggingActive,
  ]);

  return { requestConfig };
};

export default useRequestConfigBuilder;
